export const mediaPosts = [
  {
    id: 1,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7499009340549529600",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7499009340549529600",
    height: "700",
    title: "LinkedIn Post 1",
  },
  {
    id: 2,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7498637143657996288",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7498637143657996288",
    height: "700",
    title: "LinkedIn Post 2",
  },
  {
    id: 3,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7496538451731881984",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7496538451731881984",
    height: "700",
    title: "LinkedIn Post 3",
  },
  {
    id: 4,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7495455410028724224",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7495455410028724224",
    height: "700",
    title: "LinkedIn Post 4",
  },
  {
    id: 5,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7488911415228088323",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7488911415228088323",
    height: "700",
    title: "LinkedIn Post 5",
  },
  {
    id: 6,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7486394259684843520",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7486394259684843520",
    height: "700",
    title: "LinkedIn Post 6",
  },
  {
    id: 7,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7484941037824700416",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7484941037824700416",
    height: "700",
    title: "LinkedIn Post 7",
  },
  {
    id: 8,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7480959161749495808",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7480959161749495808",
    height: "700",
    title: "LinkedIn Post 8",
  },
  {
    id: 9,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7478787088281366528",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7478787088281366528",
    height: "700",
    title: "LinkedIn Post 9",
  },
  {
    id: 10,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7475523633847824384",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7475523633847824384",
    height: "700",
    title: "LinkedIn Post 10",
  },
  {
    id: 11,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7473705177993121793",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7473705177993121793",
    height: "700",
    title: "LinkedIn Post 11",
  },
  {
    id: 12,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7471167211303419907",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7471167211303419907",
    height: "700",
    title: "LinkedIn Post 12",
  },
  {
    id: 13,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7470448431526965248",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7470448431526965248",
    height: "700",
    title: "LinkedIn Post 13",
  },
  {
    id: 14,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7470075321740939265",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7470075321740939265",
    height: "700",
    title: "LinkedIn Post 14",
  },
  {
    id: 15,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7468633775048953856",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7468633775048953856",
    height: "700",
    title: "LinkedIn Post 15",
  },
  {
    id: 16,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7468267557242707969",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7468267557242707969",
    height: "700",
    title: "LinkedIn Post 16",
  },
  {
    id: 17,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7465742352708632576",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7465742352708632576",
    height: "700",
    title: "LinkedIn Post 17",
  },
  {
    id: 18,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7461401630089973762",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7461401630089973762",
    height: "700",
    title: "LinkedIn Post 18",
  },
  {
    id: 19,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7453410614787362819",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7453410614787362819",
    height: "700",
    title: "LinkedIn Post 19",
  },
  {
    id: 20,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7450874737099964416",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7450874737099964416",
    height: "700",
    title: "LinkedIn Post 20",
  },
  {
    id: 21,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:share:7292102301756850176",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:share:7292102301756850176",
    height: "940",
    title: "LinkedIn Post 21",
  },
  {
    id: 22,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:ugcPost:7285205423706578944",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7285205423706578944",
    height: "640",
    title: "LinkedIn Post 22",
  },
  {
    id: 23,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:ugcPost:7286909538450952192",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7286909538450952192",
    height: "900",
    title: "LinkedIn Post 23",
  },
  {
    id: 24,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:share:7392456359146864640",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:share:7392456359146864640?collapsed=1",
    height: "669",
    title: "LinkedIn Post 24",
  },
  {
    id: 25,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:ugcPost:7280511147110256640",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7280511147110256640",
    height: "850",
    title: "LinkedIn Post 25",
  },
  {
    id: 26,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:share:7287215270488608768",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:share:7287215270488608768",
    height: "920",
    title: "LinkedIn Post 26",
  },
  {
    id: 27,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:ugcPost:7384483270983421952",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7384483270983421952?collapsed=1",
    height: "551",
    title: "LinkedIn Post 27",
  },
  {
    id: 28,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:ugcPost:7373965150246076416",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7373965150246076416?collapsed=1",
    height: "551",
    title: "LinkedIn Post 28",
  },
  {
    id: 29,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:share:7284330615477313536",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:share:7284330615477313536",
    height: "816",
    title: "LinkedIn Post 29",
  },
  {
    id: 30,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:ugcPost:7283447284053245952",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7283447284053245952",
    height: "1150",
    title: "LinkedIn Post 30",
  },
  {
    id: 31,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:share:7389195459459813377",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:share:7389195459459813377?collapsed=1",
    height: "542",
    title: "LinkedIn Post 31",
  },
  {
    id: 32,
    postUrl: "https://www.linkedin.com/feed/update/urn:li:ugcPost:7372153953880301568",
    embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7372153953880301568?collapsed=1",
    height: "566",
    title: "LinkedIn Post 32",
  },
];
